import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
import 'Css/table.css'

function TabReddito(props: any) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_REDDITO_DICHIARATI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.redditoDichiaratoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.redditoDichiaratoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.redditoDichiaratoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.redditoDichiaratoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.redditoDichiaratoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_REDDITO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.redditoStimatoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.redditoStimatoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.redditoStimatoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.redditoStimatoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.redditoStimatoTot
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_REDDITO_ADDETTO_DICHIARATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.redditoAddDich
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.redditoAddDich
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.redditoAddDich
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.redditoAddDich
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.redditoAddDich
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_REDDITO_ADDETTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {" "}
                        {props.campo1 !== undefined
                            ? props.campo1.redditoAddSimato
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.redditoAddSimato
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo3 ? (
                    <td>
                        {" "}
                        {props.campo3 !== undefined
                            ? props.campo3.redditoAddSimato
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo4 ? (
                    <td>
                        {" "}
                        {props.campo4 !== undefined
                            ? props.campo4.redditoAddSimato
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo5 ? (
                    <td>
                        {" "}
                        {props.campo5 !== undefined
                            ? props.campo5.redditoAddSimato
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
            </tr>
        </React.Fragment>
    )
}
export default TabReddito
